/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import {
    withStyles,
    FormControl, Select, MenuItem,
} from '@material-ui/core';
import { KeyboardArrowDown } from '@material-ui/icons';
import {
    bool, number, object, shape,  func,
} from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import getPrice from '../../../../../../helpers/getPrice/getPrice';
import { selectedSkuType, skuDataType } from '../../common/types';

const styles = (theme) => ({
    dropdownRootClass: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: '4px 0',
        paddingRight: '50px  !important',
        paddingLeft: '12px',
        textAlign: 'center',
        overflowX: 'visible',
        '&:focus': {
            backgroundColor: 'transparent',
        },
        [theme.breakpoints.down('430')]: {
            paddingLeft: '6px',
        },
        [theme.breakpoints.down('370')]: {
            paddingLeft: '2px',
            paddingRight: '30px !important',
        },
    },
    DropdownSelectorIcon: {
        backgroundColor: theme.palette.colorPrimary,
        top: 'unset',
        right: '0',
        height: '100%',
        borderTopRightRadius: '4px',
        borderBottomRightRadius: '4px',
        width: '48px',
        color: theme.palette.cms?.white || '#ffffff',
        [theme.breakpoints.down('370')]: {
            width: '25px',
        },
    },
    skuLabel: {
        [theme.breakpoints.down('600')]: {
            fontSize: '15px',
        },
        [theme.breakpoints.down('430')]: {
            fontSize: '13px',
            marginRight: '10px',
        },
        [theme.breakpoints.down('370')]: {
            fontSize: '12px',
        },
    },
    DropdownItemRoot: {
        display: 'flex',
        flexDirection: 'row',
        overflow: 'visible',
        justifyContent: 'space-between',
        [theme.breakpoints.down('430')]: {
            whiteSpace: 'inherit',
        },
        [theme.breakpoints.down('370')]: {
            padding: '10px',
        },
    },
    skuLabelAmount: {
        color: theme.palette.cms?.skuAmount || '#585858',
        marginLeft: '10px',
        fontWeight: '500',
        display: 'block',
        [theme.breakpoints.down('600')]: {
            fontSize: '15px',
            textAlign: 'right',
        },
        [theme.breakpoints.down('430')]: {
            fontSize: '13px',
            marginLeft: '5px',
        },
        [theme.breakpoints.down('370')]: {
            fontSize: '12px',
            marginLeft: '0px',
        },
        '&--retail': {
            marginLeft: '5px',
            textDecoration: 'line-through',
            color: theme.palette.cms?.red || '#ed0000',
        },
        '&--sale': {
            marginLeft: '5px',
            color: theme.palette.salePriceColor || '#7DC383',
        },
    },
});

const getPassportBundleDetails = (isPassportBundleProduct, sku) => {
    let passportBundlePrice = 0;
    let passportBundleText = '';
    if (isPassportBundleProduct?.enable) {
        passportBundlePrice = Number(isPassportBundleProduct.prices?.value || 0);
        if (sku?.name?.length < 45) {
            passportBundleText = isPassportBundleProduct.skuText?.length ? ` ${isPassportBundleProduct.skuText}` : ' Bundle';
        }
    }
    return {
        passportBundlePrice,
        passportBundleText,
    };
};

const FloralDropDownContainer = ({
    isPassportBundleProduct,
    classes,
    skuDataList,
    selectedSku,
    selectProduct,
    dynamicPriceList,
}) => (
    <FormControl
        fullWidth
        hiddenLabel
        size="small"
        margin="dense"
        variant="outlined"
        classes={{ root: classes.FormControlRoot }}
    >
        <Select
            value={selectedSku.id}
            onChange={(event) => {
                selectProduct(event);
            }}
            classes={{
                root: classes.dropdownRootClass,
                icon: classes.DropdownSelectorIcon,
            }}
            IconComponent={KeyboardArrowDown}
        >
            {skuDataList.map((sku) => {
                const pricesList =  dynamicPriceList(sku);
                const currentSkuRetailPrice = Number((pricesList.length > 0 ? pricesList : sku.prices)?.find((price) => price.type === 'retail')?.value || 0);
                const currentSkuActualPriceDetails = getPrice((pricesList.length > 0 ? pricesList : sku.prices));
                const passportBundleDetails = getPassportBundleDetails(isPassportBundleProduct, sku);
                const totalRetailPrice = currentSkuRetailPrice + passportBundleDetails.passportBundlePrice;
                const retailPrice = `$${parseFloat(totalRetailPrice).toFixed(2)}`;
                const totalSalePrice = currentSkuActualPriceDetails.value + passportBundleDetails.passportBundlePrice;
                const salePrice = `$${parseFloat(totalSalePrice).toFixed(2)}`;
                const skuLabel = ReactHtmlParser(sku.name + passportBundleDetails.passportBundleText);
                return (
                    <MenuItem
                        role="option"
                        key={sku.name}
                        value={sku.id}
                        classes={{
                            root: classes.DropdownItemRoot,
                        }}
                        name={sku.name}
                    >
                        <span className={classes.skuLabel}>{skuLabel}</span>
                        <span>
                            <span className={`${classes.skuLabelAmount}${currentSkuActualPriceDetails.hasSale ? '--retail' : ''} `}>{retailPrice}</span>
                            {currentSkuActualPriceDetails.hasSale && <span className={` ${classes.skuLabelAmount}--sale`}>{salePrice}</span>}
                        </span>
                    </MenuItem>
                );
            })}
        </Select>
    </FormControl>
);

FloralDropDownContainer.propTypes = {
    classes: object.isRequired,
    dynamicPriceList: func.isRequired,
    skuDataList: skuDataType.isRequired,
    selectedSku: selectedSkuType.isRequired,
    selectProduct: func.isRequired,
    isPassportBundleProduct: shape({
        prices: {
            value: number,
        },
        enable: bool,
    }),
};
FloralDropDownContainer.defaultProps = {
    isPassportBundleProduct: {},
};

export default withStyles(styles)(FloralDropDownContainer);
